import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CheckRounded } from "@mui/icons-material";

// ----------------------------------------------------------------------

interface WizardStepperProps {
  steps: string[];
  activeIndex: number;
}

/** Stepper do wizard (dots numerados no desktop; barra de progresso no mobile) */
export default function WizardStepper({ steps, activeIndex }: WizardStepperProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    const progress = ((activeIndex + 1) / steps.length) * 100;
    return (
      <Box sx={{ mb: "20px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, fontSize: "12px" }}>
          <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "primary.main" }}>
            Passo {activeIndex + 1} de {steps.length}
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>{steps[activeIndex]}</Typography>
        </Box>
        <Box sx={{ height: 5, borderRadius: "100px", overflow: "hidden", backgroundColor: theme.palette.brand.cream }}>
          <Box sx={{ width: `${progress}%`, height: "100%", borderRadius: "100px", backgroundColor: "primary.main" }} />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", mb: "28px", maxWidth: 880, mx: "auto", width: "100%" }}>
      {steps.map((label, index) => {
        const done = index < activeIndex;
        const active = index === activeIndex;
        const ariaLabel = `Passo ${index + 1} de ${steps.length}: ${label}${active ? " (atual)" : done ? " (concluído)" : ""}`;
        return (
          <Box key={label} sx={{ display: "contents" }}>
            {index > 0 && <Box sx={{ flex: 1, height: "2px", mt: "18px", mx: "4px", backgroundColor: theme.palette.brand.heroBorder }} />}
            <Box aria-label={ariaLabel} sx={{ width: 72, textAlign: "center" }}>
              <Box
                sx={{
                  width: 38,
                  height: 38,
                  mx: "auto",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: 600,
                  backgroundColor: active
                    ? "primary.main"
                    : done
                      ? theme.palette.brand.stepDoneBg
                      : theme.palette.brand.surface2,
                  color: active ? "primary.contrastText" : done ? theme.palette.brand.stepDoneText : "text.secondary",
                }}
              >
                {done ? <CheckRounded sx={{ fontSize: 18 }} /> : index + 1}
              </Box>
              <Typography sx={{ mt: "6px", fontSize: "11.5px", fontWeight: 500, color: active ? "text.primary" : "text.secondary" }}>
                {label}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
